import React from 'react';
import { Table as ReactstrapTable } from 'reactstrap';
import { Box, IconButton, Tooltip } from '@chakra-ui/react';
import { EditIcon, DeleteIcon } from '@chakra-ui/icons';

const Table = ({
  data,
  contacts = [],
  columns,
  getRowKey,
  renderActions,
  onEdit,
  onDelete,
  handleEdit,
  handleCloseModal,
  emptyMessage = 'No records available.',
  loading = false,
  ...tableProps
}) => {
  const rows = Array.isArray(data) ? data : Array.isArray(contacts) ? contacts : [];
  const editHandler = onEdit || handleEdit;
  const deleteHandler = onDelete || handleCloseModal;

  const resolvedColumns =
    Array.isArray(columns) && columns.length > 0
      ? columns
      : [
          { header: 'Full Name', accessor: (r) => r.full_name },
          { header: 'Relationship', accessor: (r) => r.relationship_with_employee },
          { header: 'Primary Contact', accessor: (r) => r.primary_contact_number },
          { header: 'Priority', accessor: (r) => r.priority_level },
        ];

  const renderCell = (col, row) => {
    if (typeof col.cell === 'function') return col.cell(row);
    if (typeof col.accessor === 'function') return col.accessor(row);
    if (typeof col.accessor === 'string') return row?.[col.accessor];
    return null;
  };

  const getKey = (row, index) => {
    if (typeof getRowKey === 'function') return getRowKey(row, index);
    return row?.pri_contact_id ?? row?.id ?? String(index);
  };

  const hasActions = renderActions || editHandler || deleteHandler;

  return (
    <Box
      overflowX={{ base: 'auto', md: 'visible' }}
      overflowY="auto"
      width="100%"
      maxHeight="400px"         // add this — adjust height as needed
      style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'thin' }}
      sx={{
        '&::-webkit-scrollbar': { height: '8px', width: '8px' },   // add width for vertical scrollbar,
        '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '10px' },
        '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '10px' },
        '&::-webkit-scrollbar-thumb:hover': { background: '#555' },
      }}
    >
      <ReactstrapTable bordered style={{ minWidth: '600px', width: '100%' }} {...tableProps}>
        <thead>
          <tr>
            {resolvedColumns.map((col, idx) => (
              <th key={idx} 
              style=
              {{ 
                textAlign: 'center',
                 fontWeight: 'bold',
                  color: 'black',
                  position: 'sticky',  
                  verticalAlign: 'middle',
                  // top: 0,              
                  zIndex: 1,        
                  backgroundColor: 'rgb(181, 142, 228)',  //prevents content showing through
              }}>
                {col.header}
              </th>
            ))}
            {hasActions && (
              <th style={{ textAlign: 'center', fontWeight: 'bold', color: 'black' , backgroundColor: 'rgb(181, 142, 228)'}}>
                Actions
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((row, idx) => (
              <tr key={getKey(row, idx)}>
                {resolvedColumns.map((col, cidx) => (
                  <td key={cidx} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {renderCell(col, row)}
                  </td>
                ))}
                {hasActions && (
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {typeof renderActions === 'function' ? (
                      renderActions(row)
                    ) : (
                      <>
                        {editHandler && (
                          <Tooltip label="Edit">
                            <IconButton
                              icon={<EditIcon />}
                              aria-label="Edit"
                              colorScheme="yellow"
                              size="sm"
                              onClick={() => editHandler(row)}
                            />
                          </Tooltip>
                        )}
                        {deleteHandler && (
                          <Tooltip label="Delete">
                            <IconButton
                              icon={<DeleteIcon />}
                              aria-label="Delete"
                              colorScheme="red"
                              size="sm"
                              style={{ marginLeft: '8px' }}
                              onClick={() => deleteHandler(row)}
                            />
                          </Tooltip>
                        )}
                      </>
                    )}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={resolvedColumns.length + (hasActions ? 1 : 0)}
                style={{ textAlign: 'center', padding: '20px' }}
              >
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </ReactstrapTable>
    </Box>
  );
};

export default Table;